import { getPlacementList, placementHasIntermingle } from '@schibsted-nmp/advertising-companion';
import {
	Item,
	RecommendationItem,
	CrossBrandItem,
	BannerItem,
	DisplayAdsPlacement,
	ItemBadge,
	Recommendations,
	ShippingOption,
} from '../../../server/types.js';

export const isItemCMS = (item: Item) => {
	return item?.type === 'CMS';
};

export const isItemAdvertising = (item: Item) => {
	if (!item) return;
	switch (item.type) {
		case 'NATIVE':
			return true;
		case 'BANNER':
			return true;
		case 'CROSSBRAND':
			return true;
		default:
			return false;
	}
};

export const getItemId = (item: Item): string => {
	return (item as RecommendationItem).itemId ||
		(item as CrossBrandItem).id ||
		(item as BannerItem).placementId ||
		'';
};

export const canFavorite = (item: Item) => {
	return (item as RecommendationItem).canFavorite || false
};

export const getDisplayAdsPlacement = () => getPlacementList()
	.filter(placementHasIntermingle)
	.map((clientAdPlacement) => ({
			placementId: clientAdPlacement.placementId,
			gridPosition: clientAdPlacement.intermingle?.grid?.valueOf(),
		} as DisplayAdsPlacement)
	);

export const insertDisplayAds = (displayAdsPlacement: DisplayAdsPlacement[], data: Recommendations) => {
	if (displayAdsPlacement) {
		displayAdsPlacement.forEach((ad: DisplayAdsPlacement) => {
			if (data?.items?.find((r) => getItemId(r) === ad.placementId)) return;

			if (data?.items?.length < ad.gridPosition) return;

			const gridPosition = ad.gridPosition - 1;

			const part1: Item[] = data?.items?.slice(0, gridPosition);
			const part2: Item[] = data?.items?.slice(ad.gridPosition);
			const advt: BannerItem = { placementId: ad.placementId, type: 'BANNER' };
			data.items = [...part1, advt, ...part2];
		});
	}
};

export const getItemBadge = (type: string, badge?: ItemBadge, shipping?: ShippingOption) => {
	if (type === 'CROSSBRAND' && badge) {
		return {
			label: badge.label,
			style: badge.style,
			icon: 'external',
		};
	}

	if (shipping) {
		return {
			label: shipping.label,
			style: 'warning',
			icon: 'shipping',
		};
	}

	if (badge) {
		return badge;
	}
};
